const nameOf = (site) => site?.siteName || site?.name || site?.projectData?.siteName

export function siteSyncDetails(item, state = {}) {
  let body = item.siteDataInfo || {}
  try { if (item.body) body = JSON.parse(item.body) } catch {}
  const type = item.meta?.entityType
  const siteId = item.meta?.siteId || body.siteId || (type === "site-data" || type === "site" ? item.meta?.entityId : null)
  const reportId = item.meta?.reportId || body.reportId || (type === "site-overview" ? item.meta?.entityId : null)
  const records = Object.values(state.auditReports?.allReportsData || {})
  const current = state.auditReports?.currentReportData
  if (current && !records.includes(current)) records.push(current)
  const matches = (site) => siteId && [site?._id, site?.id, site?._clientId, site?.siteId].some((id) =>
    id && String(id?._id || id) === String(siteId))
  const report = records.find((record) => reportId
    ? String(record.report?._id) === String(reportId)
    : matches({ siteId: record.report?.siteId }))
  const targetSiteId = siteId || report?.report?.siteId?._id || report?.report?.siteId
  const site = [state.siteData?.currentSiteData, ...(state.siteData?.siteData || [])].find((entry) =>
    targetSiteId && [entry?._id, entry?.id, entry?._clientId, entry?.siteId].some((id) => id && String(id) === String(targetSiteId)))
  const siteName = item.meta?.siteName || nameOf(body) || nameOf(site) || nameOf(report?.siteOverview) ||
    nameOf(report?.siteInformation) || nameOf(report?.report?.siteId) || report?.report?.siteName
  const summary = type === "site-overview" ? "Site overview updated"
    : item.type === "site-create" ? "New site"
    : Object.prototype.hasOwnProperty.call(body, "overallSiteObservations") ? "Overall site observations updated"
    : "Site information updated"
  return { label: type === "site-overview" ? "Site overview" : "Site data", siteName,
    detail: [siteName, summary].filter(Boolean).join(" · ") }
}
